import { HttpResult } from 'widgets-for-react'
import { alphabetize } from '../azNavigation/azNavigationUtils'
import { Folders } from './foldersState'

type FolderOverviewItemDTO = {
  type: string
  sharepoint_id: string
  document_title: string
  document_number: string
  path: string
  introduction: string
  Centras: string[]
  Departments: string[]
  SubCentras: string[]
  SubDepartments: string[]
}

type SearchOption =
  | { Kind: 'ByTags'; Tags: string[] }
  | { Kind: 'ByDepartment'; DepartmentName: string }
  | { Kind: 'BySubdepartment'; SubdepartmentName: string }
  | { Kind: 'ByCentrum'; CentrumName: string }
  | { Kind: 'BySubcentrum'; SubcentrumName: string }

const getSearchOption = (
  department?: string,
  subdepartment?: string,
  centrum?: string,
  subcentrum?: string
): SearchOption | null =>
  department !== undefined
    ? {
        Kind: 'ByDepartment',
        DepartmentName: department,
      }
    : subdepartment !== undefined
    ? {
        Kind: 'BySubdepartment',
        SubdepartmentName: subdepartment,
      }
    : centrum !== undefined
    ? {
        Kind: 'ByCentrum',
        CentrumName: centrum,
      }
    : subcentrum !== undefined
    ? {
        Kind: 'BySubcentrum',
        SubcentrumName: subcentrum,
      }
    : null

export const foldersApi = async (
  department?: string,
  subdepartment?: string,
  centrum?: string,
  subcentrum?: string
): Promise<HttpResult<Folders>> => {
  const searchOption = getSearchOption(department, subdepartment, centrum, subcentrum)
  const res = await (searchOption != null
    ? fetch('/api/v1/patient-folders/search', {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(searchOption),
      })
    : fetch('/api/v1/patient-folders'))

  if (!res.ok)
    return {
      kind: 'failed',
      status: res.status,
    }

  const data: FolderOverviewItemDTO[] = await res.json()

  return {
    kind: 'result',
    status: 200,
    value: alphabetize(
      (item) => item.title,
      data.map((item) => ({
        kind: item.type === 'pdf' ? 'pdf' : 'page',
        title: item.document_title,
        introduction: item.introduction,
        url: item.path,
        departments: item.Departments,
        centrums: item.Centras,
        subdepartments: item.SubDepartments,
        subcentrums: item.SubCentras,
      }))
    ),
  }
}
